<div class="channel_pim_preview" [ngClass]="[styleForm.get('font').value]">
    <div class="page_offer_preview">

        <!-- Détails de l'offre -->

        <div class="title_offer">
            <div class="row marges">

                <!-- Offre "Nouveauté" -->

                <div class="col_content y_items_center">
                    <span class="tag">{{ 'offer.preview.content.new.value' | translate }}</span>
                </div>

                <!-- Nom de l'offre -->

                <div class="col y_items_center">
                    <h1 class="title" [ngStyle]="{ 'color': styleForm.get('colorTitle').value }">{{ 'offer.preview.content.title.value' | translate }}</h1>
                </div>
            </div>

            <div class="row infos_price">

                <div class="col_12 col_lg col_left">
                    <div class="row marges infos">
                        <div class="col_content y_items_center">

                            <!-- Référence -->

                            <span>{{ 'offer.preview.content.reference.value' | translate }}</span>

                        </div>
                        <div class="col_content y_items_center">

                            <!-- Type d'offre -->

                            <span class="offer_type ty-house">{{ 'offer.preview.content.type.value' | translate }}</span>

                            <!-- Ville / Pays -->

                            <span>{{ 'offer.preview.content.place.value' | translate }}</span>
                        </div>
                        <div class="col_content y_items_center">

                            <!-- Durée de l'offre -->

                            <span class="offer_type ty-calendar">{{ 'offer.preview.content.duration.value' | translate }}</span><br/>
                        </div>
                        <div class="col_content y_items_center">

                            <!-- Présentiel -->

                            <span>{{ 'offer.preview.content.presential.value' | translate }}</span>
                        </div>
                    </div>
                </div>

                <div class="col_12 col_content_lg col_right">
                    <div class="row infos x_end_lg">
                        <div class="col_content">
                            <div class="price">
                                <div class="price_info">
                                    <span class="from">{{ 'offer.preview.content.price.from.value' | translate }}</span>
                                </div>
                                <div class="price_amount">
                                    <span class="price" [ngStyle]="{ 'color': styleForm.get('colorTitle').value }">{{ 'offer.preview.content.price.value' | translate }}</span>
                                    <span>{{ 'offer.preview.content.price.byPerson.value' | translate }}</span>
                                </div>
                                <div class="price_info">
                                    <span class="participants">
                                        {{ 'offer.preview.content.startFromPriceBasedOnParticipantCount.value' | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Visuels -->

        <div class="row offer_pictures">

            <!-- Visuel principal -->

            <div class="col_12 col_md col_left">

                <img src="assets/images/offer/preview/1.jpg" alt="image">

            </div>

            <!-- Visuels secondaires -->

            <div class="col_12 col_md_6 col_right">

                <div class="row h_full">

                    <div class="col_6">
                        <img src="assets/images/offer/preview/1.jpg" alt="image">
                    </div>

                    <div class="col_6">
                        <img src="assets/images/offer/preview/1.jpg" alt="image">
                    </div>

                    <div class="col_6">
                        <img src="assets/images/offer/preview/1.jpg" alt="image">
                    </div>

                    <div class="col_6">
                        <img src="assets/images/offer/preview/1.jpg" alt="image">
                    </div>

                </div>

            </div>

        </div>

        <!-- Durée de l'offre et intérêts -->

        <div class="txt_offer">

            <p class="title" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value }">{{ 'offer.preview.content.weLike.value' | translate }}</p>

            <p class="interest">

                <!-- Intérêts -->

                <span>{{ 'offer.preview.content.interests.first.value' | translate }}</span><br/>
                <span>{{ 'offer.preview.content.interests.second.value' | translate }}</span><br/>
                <span>{{ 'offer.preview.content.interests.third.value' | translate }}</span><br/>

            </p>
        </div>

        <!-- Description -->

        <div class="txt_offer">

            <h2 class="title" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value }">{{ 'offer.preview.content.description.label.value' | translate }}</h2>

            <div class="description_offer ck-content">

                <p style="text-align:justify;">
                    {{ 'offer.preview.content.description.value' | translate }}
                </p>

            </div>

        </div>

        <!-- Compris / Non compris dans l'offre -->

        <div class="accordions">

            <!-- Compris dans l'offre -->

            <div class="accordion" #accordion [ngStyle]="{ 'border-color': styleForm.get('colorBackgroundButton').value }">
                <div class="accordion_header">
                        <span [ngStyle]="{ 'color': styleForm.get('colorBackgroundButton').value }">
                            {{ 'offer.preview.content.included.label.value' | translate }}
                        </span>
                </div>
                <div class="accordion_body">
                    <div>
                        <div class="txt_offer">

                            <p class="title_2">{{ 'offer.preview.content.included.title.value' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Non Compris dans l'offre -->

            <div class="accordion" #accordion [ngStyle]="{ 'border-color': styleForm.get('colorBackgroundButton').value }">
                <div class="accordion_header">
                    <span [ngStyle]="{ 'color': styleForm.get('colorBackgroundButton').value }">
                        {{ 'offer.preview.content.notIncluded.label.value' | translate }}
                    </span>
                </div>
                <div class="accordion_body">
                    <div>
                        <div class="txt_offer">
                            <p class="title_2">{{ 'offer.preview.content.notIncluded.title.value' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Hébergement -->

        <div class="txt_offer">

            <h2 class="title" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value }">{{ 'offer.preview.content.accommodation.label.value' | translate }}</h2>

            <div class="accommodation_offer ck-content">

                <p style="text-align:justify;">
                    {{ 'offer.preview.content.accommodation.value' | translate }}
                </p>

            </div>

        </div>

        <!-- Programme -->

        <div class="infos_program">
            <div class="txt_offer">
                <h2 class="title" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value }">{{ 'offer.preview.content.program.label.value' | translate }}</h2>
            </div>

            <!-- Sélection du jour -->

            <div class="nav_slider_program">

                <button type="button" class="btn_cta btn_small" [ngStyle]="{ 'background-color': styleForm.get('colorBackgroundButton').value }">
                    <span [ngStyle]="{ 'color': styleForm.get('colorTextButton').value }">1</span>
                </button>

                <button type="button" class="btn_cta btn_small" [ngStyle]="{ 'background-color': styleForm.get('colorBackgroundButton').value }">
                    <span [ngStyle]="{ 'color': styleForm.get('colorTextButton').value }">2</span>
                </button>

            </div>

            <!-- Slider -->

            <div class="swiper-container slider_program">
                <div class="row no_wrap swiper-wrapper">
                    <div class="col_12 col_md_6 swiper-slide">
                        <span class="day" [ngStyle]="{ 'background-color': styleForm.get('colorHighlighting').value }">{{ 'offer.preview.content.program.day.value' | translate }} 1</span>
                        <div class="row h_full content_program">
                            <div class="col_7">
                                <div class="info_program">
                                    <div class="txt_offer">
                                        <p><strong>{{ 'offer.preview.content.program.day.value' | translate }} 1</strong></p>
                                        <div class="ck-content">
                                            <ul>
                                                <li>{{ 'offer.preview.content.program.day.first.elements.first.value' | translate }}</li>
                                                <li>{{ 'offer.preview.content.program.day.first.elements.second.value' | translate }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col_5">
                                <img src="assets/images/offer/preview/1.jpg" alt="image">
                            </div>
                        </div>
                    </div>
                    <div class="col_12 col_md_6 swiper-slide">
                        <span class="day" [ngStyle]="{ 'background-color': styleForm.get('colorHighlighting').value }">{{ 'offer.preview.content.program.day.value' | translate }} 2</span>
                        <div class="row h_full content_program">
                            <div class="col_7">
                                <div class="info_program">
                                    <div class="txt_offer">
                                        <p><strong>{{ 'offer.preview.content.program.day.value' | translate }} 2</strong></p>
                                        <div class="ck-content">
                                            <ul>
                                                <li>{{ 'offer.preview.content.program.day.second.elements.first.value' | translate }}</li>
                                                <li>{{ 'offer.preview.content.program.day.second.elements.second.value' | translate }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col_5">
                                <img src="assets/images/offer/preview/1.jpg" alt="image">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>

        </div>

        <!-- Localisation(s) -->

        <div>
            <div class="txt_offer">
                <h2 class="title" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value }">{{ 'offer.preview.content.location.label.value' | translate }}</h2>
            </div>
            @if(mapInitialized) {
                <div class="map_container" leaflet [leafletOptions]="mapOptions" [leafletLayer]="marker"></div>
            }
        </div>

        <!-- Transport -->

        <br/>
        <div class="txt_offer no_border">

            <p class="title" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value }">{{ 'offer.preview.transport.title' | translate}}</p>

            <!-- Début de programme -->

            <div class="transport_infos">

                <p class="transport_moment"><strong>{{ 'offer.preview.access.program.start.value' | translate}}</strong></p>

                <p class="place">
                    <img [src]="'assets/images/icons/transport/train-station.svg'" [alt]="'train-station'"/>
                    <strong>{{ 'offer.preview.transport.trainStation.recommended.value' | translate}}</strong>
                    <span class="info" [ngStyle]="{ 'color': styleForm.get('colorTextButton').value, 'background-color': styleForm.get('colorBackgroundButton').value }" [ngxTippy]="tooltipTrainStationTemplate" [tippyProps]="{ placement: 'top', allowHTML: true, animation: false, onShow: tooltipStyle }">?</span>
                    <strong class="name" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value, 'background': styleForm.get('colorBackgroundButton').value ? rgbaToHex(styleForm.get('colorBackgroundButton').value) : '' }">{{ 'offer.preview.transport.trainStation.value' | translate}}</strong>
                </p>

                <div class="advice">
                    <p class="underline" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value, 'background': styleForm.get('colorBackgroundButton').value ? rgbaToHex(styleForm.get('colorBackgroundButton').value) : '' }"><strong>{{ 'offer.preview.transport.advice.value' | translate}}</strong></p>
                    <div class="long ck-content" [innerHTML]="'offer.preview.transport.description.value' | translate | safeHtml"></div>
                </div>

                <p class="place">
                    <img [src]="'assets/images/icons/transport/airport.svg'" [alt]="'airport'"/>
                    <strong>{{ 'offer.preview.transport.airport.recommended.value' | translate}}</strong>
                    <span class="info" [ngStyle]="{ 'color': styleForm.get('colorTextButton').value, 'background-color': styleForm.get('colorBackgroundButton').value }" [ngxTippy]="tooltipAirportTemplate" [tippyProps]="{ placement: 'top', allowHTML: true, animation: false, onShow: tooltipStyle }">?</span>
                    <strong class="name" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value, 'background': styleForm.get('colorBackgroundButton').value ? rgbaToHex(styleForm.get('colorBackgroundButton').value) : '' }">{{ 'offer.preview.transport.airport.value' | translate}}</strong>
                </p>

                <div class="advice">
                    <p class="underline" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value, 'background': styleForm.get('colorBackgroundButton').value ? rgbaToHex(styleForm.get('colorBackgroundButton').value) : '' }"><strong>{{ 'offer.preview.transport.advice.value' | translate}}</strong></p>
                    <div class="long ck-content" [innerHTML]="'offer.preview.transport.description.value' | translate | safeHtml"></div>
                </div>

            </div>

            <!-- Fin de programme -->

            <div class="transport_infos">

                <p class="transport_moment"><strong>{{ 'offer.preview.access.program.end.value' | translate}}</strong></p>

                <p class="place">
                    <img [src]="'assets/images/icons/transport/train-station.svg'" [alt]="'train-station'"/>
                    <strong>{{ 'offer.preview.transport.trainStation.recommended.value' | translate}}</strong>
                    <span class="info" [ngStyle]="{ 'color': styleForm.get('colorTextButton').value, 'background-color': styleForm.get('colorBackgroundButton').value }" [ngxTippy]="tooltipTrainStationTemplate" [tippyProps]="{ placement: 'top', allowHTML: true, animation: false, onShow: tooltipStyle }">?</span>
                    <strong class="name" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value, 'background': styleForm.get('colorBackgroundButton').value ? rgbaToHex(styleForm.get('colorBackgroundButton').value) : '' }">{{ 'offer.preview.transport.trainStation.value' | translate}}</strong>
                </p>

                <div class="advice">
                    <p class="underline" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value, 'background': styleForm.get('colorBackgroundButton').value ? rgbaToHex(styleForm.get('colorBackgroundButton').value) : '' }"><strong>{{ 'offer.preview.transport.advice.value' | translate}}</strong></p>
                    <div class="long ck-content" [innerHTML]="'offer.preview.transport.description.value' | translate | safeHtml"></div>
                </div>

                <p class="place">
                    <img [src]="'assets/images/icons/transport/airport.svg'" [alt]="'airport'"/>
                    <strong>{{ 'offer.preview.transport.airport.recommended.value' | translate}}</strong>
                    <span class="info" [ngStyle]="{ 'color': styleForm.get('colorTextButton').value, 'background-color': styleForm.get('colorBackgroundButton').value }" [ngxTippy]="tooltipAirportTemplate" [tippyProps]="{ placement: 'top', allowHTML: true, animation: false, onShow: tooltipStyle }">?</span>
                    <strong class="name" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value, 'background': styleForm.get('colorBackgroundButton').value ? rgbaToHex(styleForm.get('colorBackgroundButton').value) : '' }">{{ 'offer.preview.transport.airport.value' | translate}}</strong>
                </p>

                <div class="advice">
                    <p class="underline" [ngStyle]="{ 'color': styleForm.get('colorSubTitle').value, 'background': styleForm.get('colorBackgroundButton').value ? rgbaToHex(styleForm.get('colorBackgroundButton').value) : '' }"><strong>{{ 'offer.preview.transport.advice.value' | translate}}</strong></p>
                    <div class="long ck-content" [innerHTML]="'offer.preview.transport.description.value' | translate | safeHtml"></div>
                </div>

            </div>

        </div>

    </div>
</div>

<div #styles></div>

<ng-template #tooltipTrainStationTemplate>
    <p>{{ 'offer.preview.transport.distance.from.trainStation.value' | translate}}&nbsp;:&nbsp;<strong>1 km</strong></p>
    <p><img src="assets/images/offer/preview/transport/walk.svg" alt="walk"/><strong [ngStyle]="{ 'color': styleForm.get('colorTextButton').value }">10 min</strong></p>
    <p><img src="assets/images/offer/preview/transport/bike.svg" alt="bike"/><strong [ngStyle]="{ 'color': styleForm.get('colorTextButton').value }">10 min</strong></p>
    <p><img src="assets/images/offer/preview/transport/car.svg" alt="car"/><strong [ngStyle]="{ 'color': styleForm.get('colorTextButton').value }">10 min</strong></p>
</ng-template>

<ng-template #tooltipAirportTemplate>
    <p>{{ 'offer.preview.transport.distance.from.airport.value' | translate}}&nbsp;:&nbsp;<strong>1 km</strong></p>
    <p><img src="assets/images/offer/preview/transport/walk.svg" alt="walk"/><strong [ngStyle]="{ 'color': styleForm.get('colorTextButton').value }">10 min</strong></p>
    <p><img src="assets/images/offer/preview/transport/bike.svg" alt="bike"/><strong [ngStyle]="{ 'color': styleForm.get('colorTextButton').value }">10 min</strong></p>
    <p><img src="assets/images/offer/preview/transport/car.svg" alt="car"/><strong [ngStyle]="{ 'color': styleForm.get('colorTextButton').value }">10 min</strong></p>
</ng-template>
